import React,{useState,useEffect} from 'react'
import {Spin,Select,message,Breadcrumb} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import S3 from 'react-aws-s3';
import OrderService from '../../../services/order.service';
import userService from '../../../services/user.service';
import {Link} from 'react-router-dom';

const {Option} = Select;


const spinIcon = <LoadingOutlined style={{ fontSize: 24,color:'white' }} spin />;

function EditServices({match}) {
    const [name,setName] = useState("");
    const [details,setDetails] = useState("");
    const [readMoreLink,setReadMoreLink] = useState("");
    const [fileUrl,setFileUrl] = useState("");
    const [uploading,setUploading] = useState(false);
    const [awsData,setAwsData] = useState(null);
    const [technologiesData,setTechnologies] = useState([]);
    const [techonologiesArr,setTechnologiesArr] = useState([]);
    const [loading,setLoading] = useState("");


    const handleFileChange = async (file)=>{
        const date = new Date();
        let dd = date.getDate();
        let mm = date.getMonth() + 1;
        let yyyy = date.getFullYear()
        let hh = date.getHours();
        let minutes = date.getMinutes();
        let ss = date.getSeconds();
        let finalDate =  dd + "-" + mm + "-"+yyyy + " at "+hh + ":" +minutes + ":"+ss;
        let newFileName = file.name + " " +  finalDate

        if(awsData){
            setUploading(true);
         

            const config = {
                bucketName:awsData.bucketName,
                region:'ap-south-1',
                accessKeyId: awsData.accessKeyId,
                secretAccessKey: awsData.secretKey,
                s3Url:"https://" + awsData.bucketName + ".s3.amazonaws.com"
            }
              

            const ReactS3Client = new S3(config);
            ReactS3Client.uploadFile(file,newFileName).then(data=>{
                // console.log(data);
                setFileUrl(data.location);
                setUploading(false);
            }).catch(err=>{
                console.log(err);
                setUploading(false);
            })
        }
    }

    const getAwsInfo = async ()=>{
        try{
         const res = await OrderService.getAwsInfo();
         
         setAwsData(res.data);
        }catch(err){
            console.log(err);
        }
 
     }

     const getSingleServiceDetails  = async ()=>{
         try{
                const response  = await OrderService.getServiceById(match.params.slug);
                // console.log("Got Details : ",response.data);
                let data = response.data[0];
                let {name,details,readMoreLink,image,technologies} = data;
                if(technologies && technologies.length > 0){
                    setTechnologies(technologies)
                }
                setName(name);
                setDetails(details);
                setReadMoreLink(readMoreLink);
                setFileUrl(image);
                
         }catch(err){
             console.log(err);
             message.error(err.message ? err.message : 'Unable get service Details!');
         }
     }

     useEffect(()=>{
        getAwsInfo();
        getSingleServiceDetails();
        let isMount = true
        const getAllCategory = async ()=>{
            try{
              const response = await userService.getAllSkillsList();
              // console.log(response.data);
              if(isMount && response){
                setTechnologiesArr(response.data);
              }
            }catch(err){
              console.log(err);
              message.error(err.message ? err.message : 'Something went wrong!');
            }
          }

          getAllCategory();

          return ()=>{
            isMount = false
          }


     },[])

    useEffect(()=>{
        if(fileUrl){
            setUploading(false);
            // console.log(fileUrl);
        }
    },[fileUrl]);



    const handleSubmit = async (e)=>{
        e.preventDefault();
        let data = {
            name: name,
            details:details,
            readMoreLink:readMoreLink,
            image:fileUrl,
            technologies:technologiesData
        }
        if(!fileUrl){
            delete data.image
        }
        // console.log("Final Data : ",data);
        setLoading(true);
        try{
            const response = await OrderService.updateServiceById(match.params.slug,data);
            // console.log(response.data);
            setLoading(false);
            message.success("Updated Service Successfully!");
           
        }catch(err){
            console.log(err);
            setLoading(false);
            message.error(err.message ? err.message : 'Unable to update service!');
        }
    }



    const handleChange = (values)=>{
        // console.log(values);
        setTechnologies(values);
    }

    return (
        <div className='sessionsForBooking'>
        <Spin tip="Uploading..." spinning={uploading}>
            <Breadcrumb>
            <Breadcrumb.Item> <Link to="/profile/all-services">All Services </Link></Breadcrumb.Item>
            <Breadcrumb.Item> <Link to={`/profile/edit-service/${match.params.slug}`}>{name ? `Edit ${name}`:'Edit Details'}</Link></Breadcrumb.Item>
            </Breadcrumb>
             <div>
                <h2>Update {name ? name:'Service'}</h2>
            </div>
            <hr />
            <div>
                <form>
                    <div className="form-group">
                        <label>
                            Enter Service Name : 
                        </label>
                        <input  type="text" value={name} onChange={(e)=>{setName(e.target.value)}}  className="form-control" />
                    </div>
                    
                    <div className="form-group">
                        <label>
                            Enter Service Description : 
                        </label>
                       <textarea  value={details} onChange={(e)=>{setDetails(e.target.value)}} className="form-control"></textarea>
                    </div>

                    <div className="form-group">
                        <label>
                           Enter Read More Link:
                        </label>
                        <input  type="text" placeholder='Leave Empty if not present' value={readMoreLink} onChange={(e)=>{setReadMoreLink(e.target.value)}}  className="form-control" />
                    </div>

                    <div className="form-group">
                        <label>
                           Select Technologies:
                        </label>
                        <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        defaultValue={technologiesData}
                        filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        style={{ width: '100%' }}
                        placeholder="Please select"
                        onChange={handleChange}
                        >
                        {techonologiesArr.map((item)=>{
                        return  <Option value={item.name} key={item._id}>{item.name}</Option>
                        })}
                    </Select>
                    </div>

                    <div className="form-group">
                        <label> Upload Image for Service (leave empty if don't want to update) :</label>
                        <input type="file" className="form-control file" onChange={(e)=>{handleFileChange(e.target.files[0])}}/>  
                    </div>
                    
                    <button type="submit" 
                    onClick={(e)=>{handleSubmit(e)}} 
                    disabled = {name === "" || details === "" || fileUrl===""} 
                    className="sessionsForBooking-btn pay-btn"
                    
                    >
                   {loading ? <Spin indicator={spinIcon} /> : 'Update Service'}
                    </button>
                </form>

            </div>

            </Spin>
        </div>
    )
}

export default EditServices
